<template>
  <div id="header-panel" class="header-panel">
    <div class="header-panel__inner">
      <a href="/" class="header-panel__logo">
        <img
          src="@/assets/img/main/logo--mts.svg"
          alt="Webinar"
          class="header-panel__logo_img"
          width="104"
          height="40"
        />
      </a>
      <PrimaryHeaderMenuList
        class="header-panel__menu-list"
        @openMenu="$emit('openMenu')"
        @closeMenu="$emit('closeMenu')"
      />
      <div class="header-panel__btn-list">
        <template v-if="anchorLink !== ''">
          <VButtonMTSV2
            v-scroll-to="{
                el: anchorLink,
                offset: 0,
                duration: 0,
              }"
            class="header-panel__btn --registration --violet-gradient --m"
          ><span>{{ btnText }}</span></VButtonMTSV2
          >
        </template>
        <template v-else>
          <VButtonLinkMTSV2
            href="/user/organizer/"
            class="header-panel__btn --registration --violet-gradient --m"
          ><span>Попробовать бесплатно</span></VButtonLinkMTSV2
          >
        </template>

        <VButtonLinkMTSV2
          href="javascript:void(0);"
          class="header-panel__btn --signin --grey"
          :class="$device.isMobile ? '--s' : '--m'"
          @click="sendMetricsSigninClient"
        >
          <span>Войти</span>
        </VButtonLinkMTSV2>
      </div>
    </div>
  </div>
</template>
<script>
import PrimaryHeaderMenuList from '@/components/NewDesign/Layout/Primary/Header/Parts/PrimaryHeaderMenuList.vue'
import VButtonLinkMTSV2 from '@/components/Common/MTS/VButtonLinkMTSV2.vue'
import VButtonMTSV2 from '@/components/Common/MTS/VButtonMTSV2.vue'
import PrimaryHeaderMixin from '@/components/NewDesign/Layout/Primary/Header/mixins/PrimaryHeaderMixin'
import ABTests from '@/helpers/ABTests'

export default {
  name: 'MainHeaderSticky',
  components: { VButtonLinkMTSV2, VButtonMTSV2, PrimaryHeaderMenuList },
  mixins: [PrimaryHeaderMixin],
  data() {
    return {
      isAutotest: false,
      lastScrollTop: 0,
      anchorLink: '',
      currentUrl: '',
      btnText: 'Попробовать бесплатно',
      abFormSelectorVariant: null,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)

    if (this.$route.query.autotest === '1') {
      this.isAutotest = true
    } else {
      this.abFormSelectorVariant =
        ABTests.getABFormSelectorVariant('ab_meetings_filter')
    }
    // Получаем текущий URL
    this.currentUrl = this.$route.path

    // Проверяем, содержится ли "products" или "task" в URL
    if (
      this.currentUrl.includes('products') ||
      this.currentUrl.includes('task')
    ) {
      this.checkUrlAndSetLinkFormBtn()
    }
  },
  methods: {
    handleScroll() {
      const scrollTop = window.pageYOffset
      if (scrollTop < this.lastScrollTop && this.lastScrollTop > 119) {
        document.querySelector('#header-panel').classList.add('visible')
      } else {
        document.querySelector('#header-panel').classList.remove('visible')
      }
      this.lastScrollTop = scrollTop
    },

    // Для лендингов относяящимся к категории products или task для кнопки будет работать ссылка на форму внизу лендинга,
    checkUrlAndSetLinkFormBtn() {
      // Выполняем поиск всех форм на странице
      this.forms = Array.from(document.getElementsByTagName('form'))
      // Фильтруем формы по классам
      const filteredForms = this.forms.filter((form) => {
        const classes = form.className.split(' ')
        return (
          classes.includes('mts-registration-form__form') ||
          classes.includes('mts-application-form__form')
        )
      })

      // Если есть отфильтрованные формы, выбираем последнюю и устанавливаем id как якорь
      if (filteredForms.length > 0) {
        // Сортируем отфильтрованные формы по порядку их появления (в конце списка)
        const lastForm = filteredForms[filteredForms.length - 1]

        //Поиск ближайшего родителя с id
        const parentLastForm = lastForm.closest('div[id]')
        //для сылки используется id именно родителя. что бы скрол опускался в правильное место
        this.anchorLink = `#${parentLastForm.id}`

        //Заменатекста формы в зависимости от того какая форма используется на стр.
        if (lastForm.className.includes('application')) {
          this.btnText = 'Оставить заявку' // Меняем текст кнопки, если есть "application"
        }
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.header-panel {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 449;
  padding: 0 32px;
  transform: translateY(-50vh);
  transition: all 0.3s ease;
  background-color: $color-white;
  border-bottom: 1px solid rgba(150, 159, 168, 0.2);

  @include screen-down('lg') {
    transform: translateY(-100%);
  }

  @include screen-down('sm') {
    padding: 0 20px;
  }

  &.visible {
    transform: translateY(0);
  }

  &__inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 40px;
    max-width: 1856px;
    padding: 14px 0;
    margin: 0 auto;

    @include screen-down('sm') {
      padding: 6px 0;
    }
  }

  &__logo {
    line-height: 0;
  }

  &__btn {
   &-list {
      display: flex;
      gap: 16px;
    }

    &.--registration {
      @include screen-down('sm') {
        display: none;
      }
    }
  }

  &__menu-list {
    flex: 1;
    margin-left: 4px;

    @include screen-down('xl'){
      display: none;
    }
  }
}
</style>
